<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8bq2g1/tc-custom/9781488094170.jpg?1704489419900" alt="This image is the cover for the book Billionaire Werewolf's Princess"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Billionaire Werewolf's Princess
      </h1>
      <p class="bookDescription body article font2">
        <b>Fangs…</b><br/><br/><i>…and faery dust</i><br/><br/>Ryland James is a wealthy philanthropist. He’s also a werewolf, and the son of the Faery king. Indigo DuCharme seems like a typical socialite, but as she moves deeper into Ry’s world, something in her awakens—something she never could have imagined. She’ll need to accept her true nature if they’re going to have a chance at love, and if they’re going to protect human children from the fae.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michele Hauf
      </h2>
      
      <p class="authorDescription body article">Michele Hauf, who also writes as Michele Renae, lives in Minneapolis and has been writing since the 1990s.&#160; A variety of genres keep her happily busy at the keyboard, including historical romance, paranormal romance, action/adventure and fantasy.&#160;<Br><Br>Pinterest at: toastfaery<Br><Br>Instagram: MicheleHauf<Br><Br>Visit her website: michelehauf.com<BR />Email Michele at:&#160; <a href="mailto:toastfaery@gmail.com">toastfaery@gmail.com</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?170ff607